// Single rule for how a dealer is named on customer-facing surfaces (lists,
// detail pages, printouts, pickers): the contact's company when one is set,
// otherwise the person's "Name Surname". Mirrors UserDisplayName on the backend.
type DealerLike = {
  name?: string | null
  surname?: string | null
  contact?: { company?: string | null } | null
} | null | undefined

export const dealerDisplayName = (user: DealerLike): string => {
  const company = (user?.contact?.company || '').trim()
  if (company) return company
  return `${(user?.name || '').trim()} ${(user?.surname || '').trim()}`.trim()
}
